// src/pages/Login/AuthCallback.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { storePermissions } from '../../hooks/usePermission';

export default function AuthCallback({ onLogin }) {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const token        = params.get('token');
    const login        = params.get('login');
    const full_name    = params.get('full_name');
    const is_admin     = params.get('is_admin')       === 'true';
    const is_super_admin = params.get('is_super_admin') === 'true';
    const is_security  = params.get('is_security')    === 'true';
    const employee_id  = params.get('employee_id');
    const permissions_b64 = params.get('permissions');

    const error = params.get('error');

    if (error) {
      const messages = {
        google_cancelled:  'Вход отменён',
        google_token_failed: 'Ошибка Google авторизации',
        wrong_domain:      'Доступ разрешён только для корпоративных аккаунтов',
        not_allowed:       'Ваш аккаунт не имеет доступа к системе',
      };
      alert(messages[error] || `Ошибка входа: ${error}`);
      navigate('/');
      return;
    }

    if (!token) {
      navigate('/');
      return;
    }

    // Сохраняем всё в localStorage
    localStorage.setItem('token',          token);
    localStorage.setItem('login',          login        || '');
    localStorage.setItem('full_name',      full_name    || '');
    localStorage.setItem('is_admin',       String(is_admin));
    localStorage.setItem('is_super_admin', String(is_super_admin));
    localStorage.setItem('is_security',    String(is_security));

    if (employee_id) {
      localStorage.setItem('employee_id', employee_id);
    }

    // Парсим и сохраняем права доступа
    let permissions = null;
    if (permissions_b64) {
      try {
        const json = atob(permissions_b64.replace(/-/g, '+').replace(/_/g, '/'));
        permissions = JSON.parse(json);
        storePermissions(permissions);
      } catch (e) {
        console.warn('Failed to parse permissions:', e);
      }
    }

    onLogin(token, login, {
      permissions,
      employee_id,
    });

    navigate('/');
  }, []);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', flexDirection: 'column', gap: 16,
    }}>
      <div style={{ fontSize: 32 }}>⏳</div>
      <div style={{ color: '#6B21A8', fontSize: 16 }}>Выполняется вход...</div>
    </div>
  );
}